export const positions = {}

export const scrollStack = []
export const registerScrollListener = (el) => scrollStack.push(el)

// Guard against Node-side execution (Brender pre-render / SSR / tests):
// these listeners are browser-only and `document` is undefined when this
// module is loaded outside a browser. Without the guard, importing
// shared/functions/index.js — which is now reached by Brender's import
// graph via the freestyle/canvas glue — throws
// `document is not defined` and breaks `bun run build` for every PR.
if (typeof document !== 'undefined') {
  // Add scroll event listener
  document.addEventListener('scroll', (event) => {
    if (scrollStack.length) {
      // Filter out elements with non-existent nodes
      for (let i = scrollStack.length - 1; i >= 0; i--) {
        const v = scrollStack[i]
        if (!v.node || !document.body.contains(v.node)) {
          scrollStack.splice(i, 1)

          continue
        }
        // Was `v.on.scroll || v.onScroll`. `el.on` was REMOVED in DOMQL v3.14
        // (elements carry flat `onEvent` handlers), so `v.on` is `undefined`
        // and reading `.scroll` off it throws
        // `TypeError: Cannot read properties of undefined (reading 'scroll')`
        // — which, inside this loop, would abort the whole scroll dispatch on
        // the FIRST registered element and silently drop every subsequent
        // element's handler. Latent today only because `registerScrollListener`
        // has zero call sites in the monorepo, so `scrollStack` never fills;
        // it would have fired the moment anything registered. No v3
        // `on: { scroll: … }` authoring remains anywhere in workspace/ or
        // company/, so the flat read is the only one needed.
        const handler = v.onScroll
        if (handler) {
          handler(event, v, v.state)
        }
      }
    }
  })

  document.addEventListener('mousemove', (event) => {
    positions.mouseX = event.clientX
    positions.mouseY = event.clientY
  })
}
